import script from "./TheNavbar.vue?vue&type=script&setup=true&lang=js"
export * from "./TheNavbar.vue?vue&type=script&setup=true&lang=js"

import "./TheNavbar.vue?vue&type=style&index=0&id=3f97abed&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f97abed"]])

export default __exports__